import React from "react";

const DetailPageOffers = () => {
  return (
    <>
      <div className="display-max">
        <div className="pdp-promotion">
          <div className="pdp-promo-block">
            <div className="promo-blck">
              <div className="promo-title-blck">
                <div className="promo-title">Use Salar Shopping Voucher</div>
                <div className="promo-tnc-blck">
                  <span className="promo-tnc text-success">
                    <a href="#" onClick={(e) => e.preventDefault()} title="T&C">
                      T&C
                    </a>
                  </span>
                </div>
              </div>
              <div className="promo-desc-block">
                <div className="promo-discounted-price">
                  <div>
                    Get it for{" "}
                    <span className="text-success fs-6 font-italic">Extra Discount</span>
                  </div>
                </div>
                <div className="promo-desc mt-2">
                  Redeem coupons & vouchers for better savings
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="display-mini display-mob">
        <div className="card border-radius-lg w-97 p-1 mx-auto">
          <div className="d-flex justify-content-start align-items-end gap-2">
            <div>
              <div className="blur-shadow-avatar border rounded-circle bg-white">
                <img
                  className="avatar avatar-lg border-radius-xl p-2"
                  src="../../../assets/img/icons/voucher.gif"
                  alt="voucher"
                  onError={(e) => {
                    e.currentTarget.src = "../../../assets/img/salarlogo.png";
                  }}
                />
              </div>
            </div>
            <div>
              <div className="lh-sm">
                <b className="fw-normal text-black fs-5 letter-spacing-1">
                  Available Offers
                </b>
                <div className="mt-1">
                  <b className="text-black-50 fw-normal text-sm">
                    Redeem Salar Shopping Voucher & Coupons
                  </b>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DetailPageOffers;
